import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export default function ProfileHero({ avatar, children, className, contentClassName }) {
  return (
    <Card className={cn('overflow-hidden border border-[rgba(6,43,26,0.08)] shadow-sm', className)}>
      <div
        className="bg-gradient-to-r from-[#062B1A] to-[#2D4470] px-6 py-6 text-white"
        data-profile-hero
      >
        <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
          <div className="shrink-0">{avatar}</div>
          <div className={cn('min-w-0 flex-1 space-y-1', contentClassName)}>{children}</div>
        </div>
      </div>
    </Card>
  );
}
